// extracted by mini-css-extract-plugin
module.exports = {"card-container":"styles_card-container__1_-pk","card-icon":"styles_card-icon__1UFo6","card-content":"styles_card-content__3QhT3"};